import BaseButton from "./BaseButton";
import { BaseButtonTypes } from "./types";
type PrimaryButtonProps = Omit<
	BaseButtonTypes,
	| "fontFamily"
	| "fontSize"
	| "shape"
	| "bgColor"
	| "fontColor"
	| "buttonSize"
	| "hoverBackground"
>;

const PrimaryButton: React.FC<PrimaryButtonProps> = (props) => {
	return (
		<BaseButton
			fontFamily="font-omnes-medium"
			fontSize="text-14px"
			shape="rounded-full"
			bgColor="bg-supply-blue-400"
			fontColor="text-white"
			buttonSize="h-26px"
			hoverBackground="hover:bg-primaryDefaultHover"
			additionalClasses="text-nowrap py-1 px-3 mx-2 max-sm:mx-1"
			{...props}
		/>
	);
};

export default PrimaryButton;
